/**
 * @file Re-exports the Note component.
 */
import Note from "./Note";

export default Note;
